import React from "react"
import {
    Box,
    CalendarDatePicker,
    LinkButton,
    componentStyles,
} from "@mallardbay/lib-react-components"

import { useMobileMediaQueries } from "~components/shared/todo-lib-react-components/hooks/use-media-queries"
import COPY from "~config/copy-constants"
import HorizontalStackSpaceBetween from "~components/shared/todo-lib-react-components/horizontal-stack-space-between"
import { TextXLargeBold } from "~components/shared/todo-lib-react-components/text"

import { useSharedStyles } from "./use-shared-styles"

export default function DatepickerSearchFilter({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
}: {
    readonly startDate: number | undefined
    readonly setStartDate: (startDate: number | undefined) => void
    readonly endDate: number | undefined
    readonly setEndDate: (endDate: number | undefined) => void
}) {
    const styles = useStyles()
    const { isMobileOnly } = useMobileMediaQueries()
    const sharedStyles = useSharedStyles()
    const startDateForPicker = startDate ? new Date(startDate) : undefined
    const endDateForPicker = endDate ? new Date(endDate) : undefined
    const clearDates = () => {
        setStartDate(undefined)
        setEndDate(undefined)
    }

    return (
        <Box style={sharedStyles.wrapper}>
            <HorizontalStackSpaceBetween>
                <TextXLargeBold>{COPY.DATE_RANGE}</TextXLargeBold>
                <LinkButton
                    style={sharedStyles.linkButton}
                    onClick={clearDates}
                >
                    {COPY.CLEAR_DATES}
                </LinkButton>
            </HorizontalStackSpaceBetween>

            <CalendarDatePicker
                minDate={new Date()}
                style={styles.datePicker}
                isMulti
                startDate={startDateForPicker}
                endDate={endDateForPicker}
                isSingleMonth={isMobileOnly}
                onChange={(dates) => {
                    const firstDate = dates[0] || null
                    const lastDate = dates[dates.length - 1] || null

                    setStartDate(firstDate?.getTime())

                    setEndDate(lastDate?.getTime())
                }}
            />
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        datePicker: { border: "none", padding: 0 },
    })
}
